import { useEffect } from 'react'

export default function useHook01(callback, delay) {
  useEffect(() => {
    const fn = setTimeout(callback, delay);

    return () => clearTimeout(fn);
  }, []);
}